var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema/fetcher";
export const create = fetcher.path("/api/object_store_instances").method("post").create();
export const test = fetcher.path("/api/object_store_instances/test").method("post").create();
export const update = fetcher.path("/api/object_store_instances/{user_object_store_id}").method("put").create();
export function hide(instance) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = { hidden: true };
        const args = { user_object_store_id: String(instance === null || instance === void 0 ? void 0 : instance.uuid) };
        const { data: objectStore } = yield update(Object.assign(Object.assign({}, args), payload));
        return objectStore;
    });
}
